import * as React from 'react';
import {
    Bounce1,
    Bounce2,
    Bounce3,
    Spinner
} from './styles';

export interface InnerLoaderProps {
    backgroundColor?: string
}
export class InnerLoader extends React.Component<InnerLoaderProps, {}> {
    constructor(props: {}) {
        super(props);
    }

    public render() {
        return (
            <Spinner>
                <Bounce3 backgroundColor={this.props.backgroundColor} />
                <Bounce2 backgroundColor={this.props.backgroundColor} />
                <Bounce1 backgroundColor={this.props.backgroundColor} />
            </Spinner>
        );
    }
};

export default InnerLoader;
